// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-rch","buttons":"styles_buttons__tbDK4"};